// Generated by platfom/nginx/config-generator, update the platfom/nginx/config-generator/regex.json file instead of this one.

export default [
  new RegExp(/^\/(cheque-cadeau-whisky-fr|carte-cadeau-whisky-fr|selections\/derniers-arrivages|marque|distillerie|pays-d-origine)\.html$/),
  new RegExp(/^\/en\/(gift-card|selections\/new-arrivals|brands|distilleries|origin-countries)\.html$/),
  new RegExp(/^\/(en\/)?(amlocator|locator|store-locator|coupons-cavistes)\/?$/),
  new RegExp(/^\/(en\/)?store-locator\/[0-9]+\/?$/),
  new RegExp(/^\/(en\/)?(kitchensink)$/),
];